import { useSelector } from 'react-redux';
import { getSnackbarsSelector } from '@store/snackbars/snackbars.selectors';
import { SnackbarComponent } from './snackbar.component';
/**
 * Snackbars component.
 *
 * @author Mikhail Siutsou
 * @function Snackbars
 * @category components
 * @return {JSX.Element} snackbars component.
 */

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Snackbars = function Snackbars() {
  var snackbars = useSelector(getSnackbarsSelector);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: snackbars === null || snackbars === void 0 ? void 0 : snackbars.map(function (snackbar) {
      return /*#__PURE__*/_jsx(SnackbarComponent, {
        snackbarId: snackbar.snackbarId
      }, snackbar.snackbarId);
    })
  });
};

export { Snackbars };